export const EMAIL_FORMAT_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const trimValue = (value) => (typeof value === 'string' ? value.trim() : '');

export const normalizeEmail = (email) => trimValue(email).toLowerCase();

export const getFieldTouchKey = (entityId, fieldName) => `${entityId}-${fieldName}`;

export const touchAllFields = (items, fieldNames) => {
  return items.reduce((accumulator, item) => {
    fieldNames.forEach((fieldName) => {
      accumulator[getFieldTouchKey(item.id, fieldName)] = true;
    });

    return accumulator;
  }, {});
};
